import { Node } from '@tiptap/core'

export const ChartBanner = Node.create({
  name: 'chart_banner',

  group: 'chart_meta',
  atom: true,
  selectable: false,
  draggable: false,

  addAttributes() {
    return {
      // -------------------------
      // Patient Identity
      // -------------------------
      patient_name: { default: null },
      dob: { default: null },
      gender: { default: null },
      mrn: { default: null },

      // -------------------------
      // Encounter Context
      // -------------------------
      encounter_at_utc: { default: null },
      encounter_timezone: { default: null },
      signed_at_utc: { default: null },
      signed_timezone: { default: null },
      visit_type: { default: null },      // telehealth / in-person
      location: { default: null },
      note_type: { default: null },       // progress / consult / discharge

      // -------------------------
      // Author / Signature Context
      // -------------------------
      author_name: { default: null },
      author_role: { default: null },     // MD / DO / NP / PA
      profession: { default: null },      // ex. Physician / Nurse Practitioner
      specialty: { default: null },       // ex. Emergency Medicine 
      sign_status: { default: 'Draft' },  // Draft / Signed / Amended

      // ✅ NEW
      author_image: { default: null },
    }
  },

  parseHTML() {
    return [{ tag: 'chart-banner' }]
  },

  renderHTML({ node }) {
    const a = node.attrs

    const signed_at_utc = a.signed_at_utc
    const signed_timezone = a.signed_timezone
    const signedDisplayFormatted = formatDate(signed_at_utc, signed_timezone);

    const encounter_at_utc = a.encounter_at_utc
    const encounter_timezone = a.encounter_timezone
    const encounter_formatted = formatDate(encounter_at_utc, encounter_timezone);

    const signedLine =
    a.sign_status === 'Signed' && signedDisplayFormatted
      ? `Signed: ${signedDisplayFormatted}`
      : '';

    return [
      'chart-banner',
      { class: 'chart_banner' },

      // =========================
      // Patient Row
      // =========================
      [
        'div',
        { class: 'chart_banner_patient' },
        [
          'div',
          { class: 'patient_name_banner' },
          a.patient_name || 'Patient Name'
        ],
        [
          'div',
          { class: 'patient_demographics' },
          `DOB: ${a.dob || '—'} • ${a.gender || '—'} • MRN: ${a.mrn || '—'}`
        ]
      ],

        [
  'div',
  { class: 'chart_banner_header' },

  // =========================
  // Avatar (ALWAYS LEFT)
  // =========================
  [
    'div',
    { class: 'chart_banner_avatar' },
    a.author_image
      ? ['img', { src: a.author_image, alt: a.author_name }]
      : ['div', { class: 'chart_banner_avatar_placeholder' }]
  ],

  // =========================
  // Right-side content wrapper
  // =========================
  [
    'div',
    { class: 'chart_banner_content' },

    // =========================
    // Three-column grid
    // =========================
    [
      'div',
      { class: 'chart_banner_grid' },

      // ───── Column 1: Author
      [
        'div',
        { class: 'chart_banner_col' },
        [
          'div',
          { class: 'chart_banner_primary' },
          `${a.author_name || '—'}`
        ],
        [
          'div',
          { class: 'chart_banner_secondary' },
          a.profession || '—'
        ],
        [
          'div',
          { class: 'chart_banner_muted' },
          a.specialty || ''
        ]
      ],

      // ───── Column 2: Note
      [
        'div',
        { class: 'chart_banner_col' },
        [
          'div',
          { class: 'chart_banner_primary' },
          a.visit_type || '—'
        ],
        [
          'div',
          { class: 'chart_banner_secondary' },
          a.note_type || '—'
        ],
        [
          'div',
          { class: 'chart_banner_muted' },
          `Status: ${a.sign_status || '—'}`
        ]
      ],

      // ───── Column 3: Encounter
      [
        'div',
        { class: 'chart_banner_col' },
        [
          'div',
          { class: 'chart_banner_secondary' },
          `Visit: ${encounter_formatted || '—'}`
        ],
        [
          'div',
          { class: 'chart_banner_secondary' },
          signedLine
        ]
      ]
    ]
  ]
]



    ]
  },
})


function formatDate(isoUtcString, signerTimeZone) 
{
  if (!isoUtcString) return '';

  const date = new Date(isoUtcString); // parses "Z" correctly
  if (isNaN(date.getTime())) return isoUtcString;

  return date.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: signerTimeZone || undefined, // if omitted, uses viewer tz
    timeZoneName: 'short',
  });
}
